<template>
  <v-row>
    <v-col cols="12">
      <!-- fast state -->
      <v-card>
        <v-tabs background-color="background" color="primary" grow height="55" slider-size="4">
          <v-tab class="text-none font-weight-medium" to="/subscriptions" exact>Todas las suscripciones</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/subscriptions?status=active" exact>Activas</v-tab>
          <!-- <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/subscriptions?status=paused" exact>Pausadas</v-tab> -->
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/subscriptions?status=cancelled" exact>Canceladas</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/subscriptions?status=needs_attention" exact>Necesitan atención</v-tab>
          <v-divider vertical />
          <v-tab class="text-none font-weight-medium" to="/subscriptions?status=finalized" exact>Finalizadas</v-tab>
        </v-tabs>
      </v-card>
      <!-- end fast state -->

      <v-card class="px-0 mt-5">
        <v-skeleton-loader v-if="$store.state.subscriptions.retrieveLoader" transition="fade-transition" type="toolbar" />
        <v-toolbar v-else color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Suscripciones</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="mr-1">
              <v-query-builder :query-map="filters" model="subscription" class="mr-1" />
              <v-btn :to="{name: 'SubscriptionCreate'}" outlined color="secondary"><v-icon left small>mdi-plus</v-icon>Nuevo</v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="px-0 py-0">
          <subscription-list />
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import SubscriptionList from '@/components/subscription/SubscriptionList'
import VQueryBuilder from '@/components/VQueryBuilder/VQueryBuilder'
import ListViewMixin from '@/mixins/ListViewMixin'
export default {
  components: {
    SubscriptionList,
    VQueryBuilder
  },
  mixins: [
    ListViewMixin
  ],
  data: () => ({
    filters: [
      {
        type: 'text',
        id: 'customer__name',
        label: 'Cliente',
        operators: ['contiene']
      },
      {
        type: 'select',
        id: 'document',
        label: 'Tipo de factura',
        choices: []
      },
      {
        type: 'text',
        id: 'lines__plan__name',
        label: 'Plan',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'addons__addon__name',
        label: 'Complemento',
        operators: ['contiene']
      },
      {
        type: 'text',
        id: 'coupon__name',
        label: 'Cupón',
        operators: ['contiene']
      },
      {
        type: 'numeric',
        id: 'lines__plan__amount',
        label: 'Precio del plan',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'select',
        id: 'status',
        label: 'Status',
        choices: [
          { value: 'active', label: 'Activo' },
          { value: 'paused', label: 'Pausado' },
          { value: 'cancelled', label: 'Cancelado' },
          { value: 'finalized', label: 'Finalizado' }
        ]
      },
      {
        type: 'text',
        id: 'date_start',
        label: 'Fecha de inicio',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'text',
        id: 'next_billing',
        label: 'Próxima facturación',
        operators: ['es igual', 'es menor a', 'es mayor a']
      },
      {
        type: 'select',
        id: 'cancel_reason',
        label: 'Razón de la cancelación',
        choices: [
          { value: 'not_paid', label: 'Sin pago' },
          { value: 'no_card', label: 'Sin tarjeta de crédito o débito' },
          { value: 'fraud_review_failed', label: 'Revisión de fraude fallida' },
          { value: 'non_compliant_customer', label: 'Cliente no conforme' },
          { value: 'not_specified', label: 'No especificado' }
        ]
      },
      {
        type: 'select',
        id: 'paused_reason',
        label: 'Razón de la pausa',
        choices: [
          { value: 'tax_agency_failed', label: 'Facturación fallida' },
          { value: 'reference_expired', label: 'Referencia expirada' }
        ]
      }
    ]
  }),
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__id__in: `${this.account.country.id}, US`,
        is_sale: 'True'
      }
    })
    .then((response) => {
      if (response.data.results && response.data.results.length) {
        const index = this.filters.findIndex(filter => filter.id === 'document')
        this.filters[index].choices = response.data.results.map((document) => {
          return { label: document.name, value: document.id }
        })
      }
    })
  },
  methods: {
    getList () {
      this.$store.dispatch('subscriptions/LIST', {
        resource: 'subscriptions',
        query: this.$route.query
      })
    }
  }
}
</script>